import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { topics } from "@/mocks/news";

const navItems = [
  { label: "首页", to: "/" },
  { label: "社会爆料", to: "/category/society" },
  { label: "娱乐爆料", to: "/category/entertainment" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [topicOpen, setTopicOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setTopicOpen(false);
  }, [location.pathname, location.search]);

  const submitSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
    setMobileOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-40 border-b transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 border-background-200 backdrop-blur-md"
          : "bg-background-50 border-transparent"
      }`}
    >
      <div className="hidden md:block border-b border-background-200/70">
        <div className="mx-auto max-w-[1280px] px-6 h-9 flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-4">
            <span className="font-label tracking-wide text-foreground-700">2026年10月17日 星期六</span>
            <span className="h-3 w-px bg-background-300" />
            <span>今日更新 5 条</span>
          </div>
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-flashlight-line text-primary-500" />
              实时更新 · 未经证实内容均已标注
            </span>
            <Link
              to="/about"
              className="flex items-center gap-1 text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
            >
              我要爆料
              <i className="ri-arrow-right-s-line" />
            </Link>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[74px] gap-4">
          <Link to="/" className="flex items-center gap-3 shrink-0 cursor-pointer group">
            <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xl font-black leading-none">
              爆
            </span>
            <span className="flex flex-col">
              <span className="text-xl md:text-2xl font-black tracking-tight text-foreground-950 leading-none">
                爆料网
              </span>
              <span className="hidden sm:block font-label text-[11px] tracking-[0.22em] text-foreground-400 mt-1">
                BAOLIAO · NEWSROOM
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.slice(0, 3).map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-3.5 py-2 text-[15px] rounded-md whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? "text-primary-600 font-bold"
                      : "text-foreground-700 hover:text-primary-600"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <div
              className="relative"
              onMouseEnter={() => setTopicOpen(true)}
              onMouseLeave={() => setTopicOpen(false)}
            >
              <button
                type="button"
                onClick={() => setTopicOpen((v) => !v)}
                className="flex items-center gap-1 px-3.5 py-2 text-[15px] rounded-md text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                专题
                <i className={`ri-arrow-down-s-line transition-transform ${topicOpen ? "rotate-180" : ""}`} />
              </button>
              {topicOpen && (
                <div className="absolute left-0 top-full pt-2 w-[320px]">
                  <div className="rounded-lg border border-background-200 bg-background-50 p-2 animate-fade-in">
                    {topics.map((topic) => (
                      <Link
                        key={topic.id}
                        to={`/topic/${topic.id}`}
                        className="flex items-start gap-2 px-3 py-2 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
                      >
                        <i className="ri-flashlight-fill text-primary-500 mt-1" />
                        <span>
                          <span className="block text-sm font-medium text-foreground-900">
                            {topic.name}
                          </span>
                          <span className="block text-xs text-foreground-500 mt-0.5">
                            {topic.subtitle}
                          </span>
                        </span>
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `px-3.5 py-2 text-[15px] rounded-md whitespace-nowrap transition-colors cursor-pointer ${
                  isActive ? "text-primary-600 font-bold" : "text-foreground-700 hover:text-primary-600"
                }`
              }
            >
              关于我们
            </NavLink>
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <form onSubmit={submitSearch} className="hidden md:flex items-center relative">
              <i className="ri-search-line absolute left-3 text-foreground-400 text-[15px]" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索爆料关键词"
                aria-label="搜索爆料"
                className="w-[180px] lg:w-[220px] h-9 pl-9 pr-3 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
              />
            </form>
            <Link
              to="/about"
              className="hidden sm:inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-megaphone-line" />
              提供线索
            </Link>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMobileOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-800 text-xl cursor-pointer"
            >
              <i className={mobileOpen ? "ri-close-line" : "ri-menu-line"} />
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <div className="px-4 py-4 space-y-4">
            <form onSubmit={submitSearch} className="flex items-center relative">
              <i className="ri-search-line absolute left-3 text-foreground-400" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索爆料关键词"
                aria-label="搜索爆料"
                className="w-full h-11 pl-9 pr-3 rounded-md bg-background-100 border border-background-200 text-sm focus:outline-none focus:border-primary-400"
              />
            </form>
            <div className="flex flex-col">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  className={({ isActive }) =>
                    `h-11 flex items-center justify-between px-3 rounded-md text-[15px] cursor-pointer ${
                      isActive ? "bg-primary-50 text-primary-700 font-bold" : "text-foreground-800"
                    }`
                  }
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-foreground-400" />
                </NavLink>
              ))}
            </div>
            <div className="pt-2 border-t border-background-200">
              <p className="px-3 text-xs tracking-widest text-foreground-400 mb-2 font-label">HOT TOPICS</p>
              <div className="grid grid-cols-2 gap-2">
                {topics.map((topic) => (
                  <Link
                    key={topic.id}
                    to={`/topic/${topic.id}`}
                    className="px-3 py-2 rounded-md bg-background-100 text-[13px] text-foreground-700 cursor-pointer truncate"
                  >
                    {topic.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}